import axios from '../../axios'

/**
 * 1.4.1 获取所有年级信息
 * @returns {Promise | Promise<unknown>}
 */
export const list = () => {
  return axios({
    url: '/clubExamines/grade/list',
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/examines/grade.js